<template>
  <div class="the-navbar__user-meta flex items-center ml-4 mr-4">
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
        <span style="margin-left: 2px" v-if="totalWarning > 0" >
        <feather-icon icon="BellIcon" class="cursor-pointer mr-1 "/>
        <span v-if="totalWarning > 0" class="badge badge-up badge-pill bg-danger p-0">{{badgesNotify(totalWarning)}}</span>
        </span>
        <span style="margin-left: 2px" v-if="totalWarning == 0">
        <feather-icon icon="BellIcon" class="cursor-pointer mr-1 "/>
        </span>
    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown" >
      <div class="notification-top text-center"
           style="padding: 1.2rem 0 2.5rem 1.28rem;background-color: rgb(var(--vs-primary))">
        <h4 class="notification-title mb-0 mr-auto"
            style="font-size:1.286rem ;color: white;cursor: pointer;float: left;font-weight: 530">{{$t('warningManager.notification')}}</h4>
      </div>
      <div class="notification-top text-center text-gray bg-white"
           style="border-bottom: 0.025rem solid #ebe9f1;padding: 1rem 1rem 2rem 1rem;">
        <h4 class="notification-title mb-0 mr-auto font-semibold"
            style="font-size:1rem ;color: #7B768C;cursor: pointer;float: left;font-weight: 530">
          {{$t('warningManager.negativeNews')}}</h4>
      </div>
      <VuePerfectScrollbar  ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0"
                           :settings="settings"
                            style="height: 13.45rem;">
        <ul class="bordered-items">
          <li v-for="(item,index) in unreadNotifications" :key="index"
              class=" justify-between px-2  notification cursor-pointer " @click="openUrl(item)" :style="item.style" style="height: 63px">
            <div class="flex items-start "  style="height: 100%">
              <div class="mx-1 my-2">
                <img :src="item.domainImage" style="width:3rem;height:3rem;border-radius: 0.313rem;">
              </div>
              <div class="mx-2 " style="padding: 0.8rem 0.2rem 0.2rem 0.2rem !important;">
                <div class="media-aside" style="display: flex;">
                  <span class="title-line" style="-webkit-line-clamp: 1;-webkit-box-orient: vertical; overflow: hidden; display: -webkit-box;"><b>{{item.details.content.split(':')[1]}} </b></span>
                </div>
                <small class="whitespace-no-wrap" style="color: rgb(185, 185, 195)">{{elapsedTime(item.createdDate) }}</small>
              </div>
            </div>
          </li>
        </ul>
      </VuePerfectScrollbar>
      <div class="notification-top text-center text-gray bg-white"
           style="border-bottom: 0.025rem solid #ebe9f1;padding: 1rem 1rem 2rem 1rem;" >
        <h4 class="notification-title mb-0 mr-auto font-semibold"
            style="font-size:1rem ;color: #7B768C;cursor: pointer;float: left;font-weight: 530;">
          {{$t('warningManager.generalNotification')}}</h4>
        <a @click="routerListNotification" class="cursor-pointer font-semibold"
           style="float: right;margin: -0.4rem 1.2rem;padding: 0.2rem">{{$t('button.seeMore')}}</a>
      </div>
      <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0"
                           :settings="settings"
                            style="height: 8rem">
        <ul class="bordered-items">
          <li v-for="(item, indexNoti) in responseData" @click="routerListNotification" :key="indexNoti"
              class=" justify-between px-2  notification cursor-pointer " >
            <div class="flex items-start " :style="item.style" style="height: 100%">
              <div class=" my-2" style="margin-left: 3px;background-color: rgba(39,125,246,.12);border-radius: 50%!important;transform: scale(0.8)" >
                <feather-icon icon="ListIcon" style="width:3rem;height:3rem;color: rgb(var(--vs-primary));justify-content: center;transform: scale(0.7)">
                </feather-icon>
              </div>
              <div class="ml-2" style="padding: 0.8rem 0.2rem 0.2rem 0.2rem !important">
                <div class="media-aside" style="display: flex;">
                  <span class="title-line" style="-webkit-line-clamp: 2;-webkit-box-orient: vertical; overflow: hidden; display: -webkit-box;"><b>{{item.title }} </b></span>
                </div>
                <small class="whitespace-no-wrap" style="color: rgb(185, 185, 195)">{{elapsedTime(item.createdDate) }}</small>
              </div>
            </div>
          </li>
        </ul>
      </VuePerfectScrollbar>
      <div class=" vx-col w-full my-2 footer cursor-pointer"
           @click="routerListWarningAll">
        <button class="vs-component vs-button w-full vs-button-primary vs-button-border cursor-pointer" @click="routerListWarningAll">{{$t('button.seeAll')}}</button>
      </div>
    </vs-dropdown-menu>
  </vs-dropdown>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import NoImage from '@/assets/images/logo/no_image.png';
import moment from "moment";

export default {
  components: {
    VuePerfectScrollbar,
    moment
  },
  data() {
    return {
      displayPopup: false,
      checkNav: false,
      dataRow: [],
      countDate: null,
      rangeDate: null,
      length: null,
      unreadNotifications: [],
      unreadNotificationsNum: 0,
      settings: {
        maxScrollbarLength: 80,
        wheelSpeed: .60,
        height: "300px",
      },
      responseData : [],
      totalWarning: 0
    }
  },
  methods: {

    badgesNotify: function (number) {

      if(number==0){
        return ;
      }
      if(number>9){
        return "9+";
      }
      if(number>99){
        return "99+";
      }
      if(number>999){
        return "999+";
      }
      return  number;
    },
    elapsedTime(startTime) {
      let x = new Date(startTime)
      let now = new Date()
      var timeDiff = now - x
      timeDiff /= 1000
      var seconds = Math.round(timeDiff)
      timeDiff = Math.floor(timeDiff / 60)
      var minutes = Math.round(timeDiff % 60)
      timeDiff = Math.floor(timeDiff / 60)
      var hours = Math.round(timeDiff % 24)
      timeDiff = Math.floor(timeDiff / 24)
      var days = Math.round(timeDiff % 365)
      timeDiff = Math.floor(timeDiff / 365)
      var years = timeDiff
      if (years > 0) {
        return years + (years > 1 ? ' Năm ' : ' Năm ') + 'trước'
      } else if (days > 0) {
        return days + (days > 1 ? ' ngày ' : ' ngày ') + 'trước'
      } else if (hours > 0) {
        return hours + (hours > 1 ? ' giờ ' : ' giờ ') + 'trước'
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? ' phút ' : ' phút ') + 'trước'
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? ' giây trước' : 'Vừa xong')
      }
      return 'Vừa Xong'
    },
    imgError(image) {
      image.target.src = NoImage;
    },
    getListFacebookWarning: function () {
      const payload = {
        start: 0,
        length: 10
      };
      this.$processor.post('warning-message/list', payload).then((res) => {
        this.dataRow = res.data;
        this.length = res.data.length;
        if(res.data.length > 0){
          this.totalWarning = res.data.filter(el => el.seenStatus == 0).length;
        }
        if(res.data.length < 1){
          this.totalWarning = 0;
        }
        this.dataRow.forEach(el => {
          let details = JSON.parse(el.body)
          el.details = details;
          if (el.details && el.details.attachmentUrls.length > 0) {
            el.domainImage = el.details.attachmentUrls[0].url;
          } else {
            el.domainImage = NoImage;
          }
          el.name = el.title;
          el.date = el.createDate;
          let dateNow = new Date().getDate();
          let createdDate = new Date(el.createdDate).getDate();
          this.rangeDate = dateNow - createdDate;
        })
        this.unreadNotifications = res.data.map(item => {
          item.style = {
            'background-color': item.seenStatus == 0 ? '#f5f6f8' : '#fff'
          }
          return item;
        })
        this.unreadNotificationsNum = this.unreadNotifications.reduce((unreadNum, item) => {
          if (item.seenStatus == 0) unreadNum++;
          return unreadNum;
        }, 0)
        this.unreadNotifications=this.unreadNotifications.slice(0,20);
      }).catch(() => {
      })
    },
    getListNotification: function (){
      const  payload ={
        start:0,
        length:10
      }
      this.$business.post('notification/list', payload).then((res) =>{
        let  data = res.data;
        data.forEach(el => {
          el.created = moment(el.createdDate).format('DD/MM/YYYY HH:mm:ss');
        })
        this.responseData = res.data;
      })
    },
    openUrl(ntf) {
      document.getElementsByClassName('con-vs-dropdown--menu')[0].style.display = 'none';
      let body = JSON.parse(ntf.body)
      const id = ntf.id;
      this.$processor.post('/warning-message/seen/' + id)
        .then((res) => {
          this.loadDataNofity +=1;
          this.$eventBus.$emit('loadDataNotify',this.loadDataNofity);
          this.getListFacebookWarning();
        })
        .catch(() => {})
        .finally(() => {
        let url = body.screenUrl;
        if (url && url.trim().length) {
          url = url + "?" + this.buildUrlParams(body.params)
        } else {
          setTimeout(() => {
            this.loadNotifications();
          }, 500)
        }
      });
      this.$processor.post('/notification/seen/' + id);
      if (id) {
        this.$router.push('/user/warning-manager?id=' + id).catch(() => {
        });
      }
    },
    openUrlInPopup() {
      let body = JSON.parse(this.selectedNtf.data.body)
      const id = body.id;
      this.$processor.post('/warning-message/seen/' + id).then(() => {
      }).catch(() => {
      }).finally(() => {
        let url = body.screenUrl;
        if (url && url.trim().length) {
          url = url + "?" + this.buildUrlParams(body.params)
          location.href = url
        } else {
          setTimeout(() => {
            this.loadNotifications();
          }, 500)
        }
      });
    },
    routerListWarning: function (id) {
      if (id) {
        this.$router.push('/user/warning-manager?id=' + id).catch(() => {
        });
      } else
        this.$router.push('/user/warning-manager').catch(() => {
        });
    },
    routerListWarningAll: function () {
      document.getElementsByClassName('con-vs-dropdown--menu')[0].style.display = 'none';
      this.$router.push('/user/warning-manager')
    },
    routerListNotification: function () {
      document.getElementsByClassName('con-vs-dropdown--menu')[0].style.display = 'none';
      this.$router.push('/user/manager-notification-message').catch(() => {});
    },
    backToManager: function () {
      this.$router.push('/user/warning-info').catch(() => {
      });
    }
  },
  props: {
    freshData: {default: 0}
  },
  watch: {
    freshData: function (newVal, oldVal) {
      this.getListFacebookWarning();
    }
  },
  async created() {
    if(this.$messaging && this.$messaging.onMessage){
      this.$messaging.onMessage((payload) => {
      let color = "success;"
      if (payload.data.type == "warning") {
        color = "danger"
      }
      this.selectedNtf = payload;
      setTimeout(() => {
        this.getListFacebookWarning();
      }, 1000)
      return this.$vs.notify({
        text: payload.notification.title,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: color,
        click: this.openUrlInPopup

      });
    });
    }
    this.getListFacebookWarning();
    this.getListNotification();

    const verticalNav = localStorage.getItem('mainLayoutType');
    if (verticalNav && verticalNav == 'vertical') {
      this.checkNav = true;
    } else {
      this.checkNav = false;
    }
  },
}
</script>
<style>
* {
  letter-spacing: 0.009rem;
  list-style-position: outside;
  list-style-type: none;
  direction: ltr;
}

.dropdown-custom .vs-dropdown--menu--after {
  right: 6px !important;
}
.notification-dropdown, .cart-dropdown {
  width: 25rem;
  height: 483px;
}
.items-star {
  height: 4.238rem !important;
}
.title-line {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.313;
  color: rgb(110, 107, 123);
}
.scroll-area--nofications-dropdown {
  height: 100%;
}
/*.bg-primary {*/

.badge.badge-up {
  position: absolute;
  top: -8px;
  min-width: 1.429rem;
  min-height: 1.429rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: .786rem;
  line-height: .786;
}
.badge-pill {
  border-radius: 10rem;
}
 .badge.badge-up {
   left: 12px;
   padding-left: 6px;
   padding-right: 3px;
   top: -10px;
}
.badge {
  color: #fff;
}
.badge {
  display: inline-block;
  font-size: 85%;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  vertical-align: baseline;
  -webkit-transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,background 0s,border 0s,-webkit-box-shadow .15s ease-in-out;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,background 0s,border 0s,-webkit-box-shadow .15s ease-in-out;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,background 0s,border 0s;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,background 0s,border 0s,-webkit-box-shadow .15s ease-in-out;
}
/*  background-color: #ff5757  !important;*/
/*}*/
.svg-icon {
  width: 2em;
  height: 2rem;
}

.svg-icon path,
.svg-icon polygon,
.svg-icon rect {
  fill: #626262;
}

.svg-icon circle {
  stroke: #4691f6;
  stroke-width: 1;
}
.footer{
  padding: 0 1.28rem 0 1.28rem;
}


</style>
